import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PrivacyPolicy = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchPrivacyPolicy();
  }, []);

  const fetchPrivacyPolicy = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/cms/settings`);
      setContent(response.data.privacy_policy || 'Privacy Policy content coming soon.');
      setLoading(false);
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
      setContent('Privacy Policy content coming soon.');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen pt-20 flex items-center justify-center">
        <div className="text-[#2d2d2d]">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-5xl font-light text-[#2d2d2d] mb-8">Privacy Policy</h1>
        <div className="prose prose-lg max-w-none">
          <div className="text-[#2d2d2d] font-light leading-relaxed whitespace-pre-wrap">
            {content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
